/** Default fit view used on first render and whenever the map resets. */
export const SPOT_GRID_DEFAULT_ZOOM = 1;

/** Furthest supported zoom-out level when the host opts in. */
export const SPOT_GRID_MIN_ZOOM = 0.5;

/** Maximum pinch zoom for the interactive spot grid. */
export const SPOT_GRID_MAX_ZOOM = 2.5;

/** Scale delta treated as "at min zoom" when suppressing the library's initial callback. */
export const NEAR_MIN_ZOOM_EPSILON = 0.01;

/** Debounce before notifying parent of zoom scale (avoids per-frame RoomLayoutMap re-renders). */
export const ZOOM_VIEWPORT_RESIZE_DEBOUNCE_MS = 120;
